
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogIn, LogOut } from "lucide-react";
import { useAuthContext } from "@/contexts/auth";

interface AuthButtonsProps {
  onNavigate?: () => void;
  variant?: 'horizontal' | 'vertical';
}

export function AuthButtons({ onNavigate, variant = 'horizontal' }: AuthButtonsProps) {
  const { isAuthenticated, signOut, user } = useAuthContext();
  
  console.log("[AuthButtons] Rendering con stato auth:", {
    isAuthenticated,
    hasUser: !!user,
    userId: user?.id
  });
  
  const handleLogout = async () => {
    try {
      await signOut();
      // Only call onNavigate if it's a function and after successful signOut
      if (onNavigate && typeof onNavigate === 'function') {
        onNavigate();
      }
    } catch (error) {
      console.error("Logout error:", error);
      // Don't call onNavigate if there was an error during signOut
    }
  };

  if (isAuthenticated) {
    return (
      <Button 
        onClick={handleLogout} 
        size="sm" 
        variant="outline"
        className={variant === 'vertical' ? "mt-4" : ""}
      >
        <LogOut className="h-4 w-4 mr-2" />
        Esci
      </Button>
    );
  }

  return (
    <Button 
      asChild 
      size="sm"
      className={variant === 'vertical' ? "mt-4" : ""}
    >
      <Link to="/auth/login" onClick={typeof onNavigate === 'function' ? onNavigate : undefined}>
        <LogIn className="h-4 w-4 mr-2" />
        Accedi
      </Link>
    </Button>
  );
}
